export interface RecipeStep {
  step: number;
  instruction?: string;
  description?: string;
  youtubeUrl?: string;
  timerEnabled?: boolean;
  timer?: number;
  timerUnit?: "min" | "sec" | "hr";
  temperature?: string;
  temperatureUnit?: "C" | "F";
  techniqueNotes?: string;
  warningEnabled?: boolean;
  warnings?: string;
  mediaUrls?: string[];
  /**
   * Critical control point: something in this step is critical. Only a flag.
   * Absent means not flagged. Saving the steps replaces the whole list, so every
   * rebuild of a step must carry this through or the flag is silently cleared.
   */
  isCcp?: boolean;
}

export function makeEmptyStep(index: number): RecipeStep {
  return { step: index + 1, instruction: "" };
}

export function hydrateStep(raw: RecipeStep, i: number): RecipeStep {
  return {
    ...raw,
    step: i + 1,
    youtubeUrl: raw.youtubeUrl?.trim() || undefined,
    timerEnabled: raw.timerEnabled ?? raw.timer != null,
    warningEnabled: raw.warningEnabled ?? raw.warnings != null,
  };
}

export function formatTimer(timer: number, unit?: "min" | "sec" | "hr"): string {
  if (unit === "sec") return `${timer}s`;
  if (unit === "hr") return `${timer}h`;
  return `${timer}m`;
}

export function timerToSeconds(timer: number, unit?: "min" | "sec" | "hr"): number {
  if (unit === "sec") return timer;
  if (unit === "hr") return timer * 3600;
  return timer * 60;
}
